// ** Initial State
const initialState = {
  total: 1,
  allData: [],
  loading: false
}

const CertificateReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA':
      return {
        ...state,
        allData: action.allData,
        total: action.totalPages,
        loading: action.loading
      }
      case 'LOADING_DATA':
        return {
          ...state,
          loading: action.loading
        }
      case 'UPDATE_STATUS':
      return {
        ...state,
        allData: action.allData
      }
    default:
      return state
  }
}

export default CertificateReducer
